import type { Error, Validator } from '@ps/web-shared-validators';
import { memoize, values } from 'lodash';
import type { Required } from 'utility-types';

import { request } from '@swf/core/api/request';
import type { RequestOptions } from '@swf/core/types/Request';

import { DocumentTypeCatPortugal } from '../types/Cashier';

const DOC_NUMBER_LENGTH = 8;

const isCorrectFormat = (value: string) =>
  value && /^\d+$/.test(value) && value.length === DOC_NUMBER_LENGTH;

export const uniqueDocNumber = (
  options: Required<Partial<RequestOptions>, 'meta'>,
  message: Error['message']
) => {
  const isUniqueDocNumber: Validator = memoize(
    async (value: string): Promise<Error> => {
      if (isCorrectFormat(value)) {
        try {
          await request({
            ...options,
            method: 'POST',
            http: true,
            service: '/api/v1-preview/account/docNumber/verifyUnique',
            body: { docType: DocumentTypeCatPortugal.NATIONAL_CIVIL_ID, docNumber: value }
          });
          return {
            valid: true
          };
        } catch {
          return {
            valid: false,
            message
          };
        }
      }
      return {
        valid: false,
        message
      };
    },
    (...args) => values(args).join('_')
  );

  return isUniqueDocNumber as Validator;
};
